import {Component, OnInit} from '@angular/core';
import {LoaderService, ReportService} from '@app/shared/services';

import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {UtilsInjectable} from '@app/shared';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-sale-return-list',
  templateUrl: './sale-return-list.component.html',
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    PaginationComponent
  ],
  styleUrls: ['./sale-return-list.component.scss']
})
export class SaleReturnListComponent implements OnInit {

  public user_rights: any;
  public user_data: any = {};
  public now = new Date();
  public sale_details: any = [""];
  public sale_data: any = [];
  public sale: any =
    {
      search_sale: ''
    }
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;

  status: any;
  index: any;
  router: any;
  saled: any;
  closeResult = "";
  public item_list: any = [];
  total = 0;
  price_total = 0;
  disc_total = 0;

  constructor(
    private loaderService: LoaderService,
    private modalService: NgbModal,
    public rest: ReportService,
    protected utils: UtilsInjectable
  ) {

  }


  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getSaleReturnList();
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public getSaleReturnList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      sale_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.listReturnSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.sale_data = result['data'];
        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
      }
    });
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.sale.search_sale,
      sale_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.listReturnSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.sale_data = result['data'];
        this.collection = result['total_count'];
        const i = this.sale_data.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.status = result['status'];
      }
    });
  }

  public clear_search() {
    if (this.sale.search_sale != '') {
      this.sale.search_sale = '';
      this.getSaleReturnList();
    }
  }

  getSum() {
    let total = 0;
    let price = 0;
    let disc = 0;

    for (const item of this.item_list) {
      total = total + parseFloat(item.TOTAL);
      price = price + parseFloat(item.RETURN_TOTAL);
      disc = disc + parseFloat(item.DISCOUNT);
    }
    this.total = total
    this.price_total = price
    this.disc_total = disc

  }

  public sale_items(item: any) {
    const postData = {
      sale_return_id: item.SALE_RETURN_ID
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.rest.getReturnSale(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.saled = result['data'];
        this.item_list = result['data'].SALE_RETURN;
        this.getSum();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  protected open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
